// extracted by mini-css-extract-plugin
module.exports = {"L_12":"L_L_12__90GY_","product-detail-L2":"L_product-detail-L2__2MH3q"};